import { FolderMedicationsWorksStore } from './folder-medications-works.store';
import { Component, effect, inject, input } from '@angular/core';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ShortDatePipe } from '../../../../../shared/pipes/short-date.pipe';
import { TableModule } from '@openng/optimus-ui/table';
import { TranslatePipe } from '@ngx-translate/core';
import { UserChipComponent } from '../../../../../../components/kit/user-chip/user-chip.component';
import { FolderMedicationObject, WorkGridItemObject } from '@it2go/types';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { getMedicationWorks } from './folder-medications-works.query';
import { workUri } from '../../../../../../utils/router.utils';
import { Router } from '@angular/router';
import { LoadingComponent } from '../../../../../../components/kit/loading/loading.component';

@Component({
    selector: 'app-folder-medications-works',
    templateUrl: './folder-medications-works.component.html',
    styleUrl: './folder-medications-works.component.scss',
    providers: [FolderMedicationsWorksStore],
    imports: [
        ButtonComponent,
        PrimeTemplate,
        ShortDatePipe,
        TableModule,
        TranslatePipe,
        UserChipComponent,
        LoadingComponent,
    ],
})
export class FolderMedicationsWorksComponent {

    public readonly store = inject(FolderMedicationsWorksStore);
    public readonly router = inject(Router);

    public readonly medication = input.required<FolderMedicationObject>();

    constructor() {
        effect(() => {
            this.store.api.getFolderMedications(
                FilterBuilder.filterById(this.medication().id),
                getMedicationWorks,
            );
        });
    }

    public navigateWork(work: WorkGridItemObject): void {
        this.router.navigateByUrl(workUri(work, work.serviceId));
    }

}
